import {
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import {
  AddEmployeesButton,
  AddEmployeesDialogContent,
  AddEmployeesToWebinarListItem,
  SearchEmployeesInputContainer,
} from '../BookingWidgetStyles'
import { getCompanyEmployees } from 'src/business/services/APIs/Subscriber/getUserData'
import { mediaURL } from 'src/consumer/services'
import Cancel from '@mui/icons-material/Cancel'
import CheckBox from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank'
import { CustomInput } from 'src/consumer/components/helperComponents'
import debounce from 'lodash/debounce'
import { postBPDataWithParams, postBPDataWithoutParams } from 'src/business/services'
import { BusinessProfileContext } from 'src/business/context/BusinessProfileContext'
import { toast } from 'react-toastify'
import { StyledAddStaffButton } from 'src/clinic/views/onboardng/ClinicOnboardingStyles'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'

export default function AddEmployeesToWebinarDialog({ webinarDetails, closeDialog }) {
  const { businessCustomerDetails } = useContext(BusinessProfileContext)
  const [availableEmployees, setAvailableEmployees] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedEmployees, setSelectedEmployees] = useState([])
  const [search, setSearch] = useState('')
  const [saving, setSaving] = useState(false)

  function selectUnselectEmployee(employee) {
    setSelectedEmployees((prev) => {
      if (prev.some((emp) => emp.businessMember.id === employee.businessMember.id)) {
        return prev.filter((emp) => emp.businessMember.id !== employee.businessMember.id)
      } else {
        return [...prev, employee]
      }
    })
  }

  function unselectEmployee(empToUnselect) {
    console.log({ empToUnselect })
    setSelectedEmployees((prev) =>
      prev.filter((emp) => emp.businessMember.id !== empToUnselect.businessMember.id),
    )
  }

  async function getAvailableEmployees(searchInput) {
    const res = await getCompanyEmployees(1, 100, {
      search: searchInput === '' ? null : searchInput,
    })
    if (res?.data?.content) {
      setAvailableEmployees(res.data.content)
    }
  }

  function handleSearchChange(e) {
    setLoading(true)
    setSearch(e.target.value)
  }

  async function handleAddEmployeesToWebinar() {
    setSaving(true)
    const res = await postBPDataWithParams(
      '/api/secure/bc/event/add-users',
      selectedEmployees?.map((emp) => emp?.businessMember?.id),
      { companyId: businessCustomerDetails?.id, bookedEventId: webinarDetails?.id },
    )
    if (res?.status === 200 && isCommonResponseSuccessful(res)) {
      closeDialog()
      toast.success('Employees added successfully')
    } else {
      toast.error('Error adding employees')
    }
    setSaving(false)
  }

  // async function Setup() {
  //   setLoading(true)
  //   await getAvailableEmployees()
  //   setLoading(false)
  // }

  const debouncedSearch = useCallback(
    debounce(async (value) => {
      await getAvailableEmployees(value)
      setLoading(false)
    }, 500),
    [],
  )

  useEffect(() => {
    debouncedSearch(search)
  }, [search])

  // useEffect(() => {
  //   Setup()
  // }, [])

  return (
    <>
      <DialogTitle>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
          <span>Assign employees to {webinarDetails?.title}</span>
          <SearchEmployeesInputContainer>
            <CustomInput
              inputAnsMessageContainerStyles={{
                padding: '6px 10px',
                fontWeight: '400',
                fontSize: '16px',
              }}
              placeholder="Search..."
              value={search}
              onChange={handleSearchChange}
            />
          </SearchEmployeesInputContainer>
          <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
            {selectedEmployees?.map((emp, idx) => (
              <Chip
                key={idx}
                size="medium"
                onClick={() => unselectEmployee(emp)}
                label={
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Avatar
                      src={
                        emp?.userProfileResponse?.profilePicId
                          ? `${mediaURL}${emp?.userProfileResponse?.profilePicId}`
                          : null
                      }
                      sx={{ mr: 1, height: '25px', width: '25px' }}
                      sizes="small"
                    />
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'start',
                        flexDirection: 'column',
                      }}
                    >
                      <strong>{emp?.businessMember?.name}</strong>
                    </div>
                    <Cancel sx={{ fontSize: '20px', color: '#b73c3c' }} />
                  </div>
                }
              />
            ))}
          </div>
        </div>
      </DialogTitle>
      <AddEmployeesDialogContent>
        {loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            {availableEmployees?.map((emp, idx) => (
              <AddEmployeesToWebinarListItem
                key={emp?.businessMember?.id}
                onClick={() => selectUnselectEmployee(emp, idx)}
              >
                <div style={{ marginRight: '25px' }}>
                  {selectedEmployees.some(
                    (selectedEmp) => selectedEmp?.businessMember?.id === emp?.businessMember?.id,
                  ) ? (
                    <CheckBox />
                  ) : (
                    <CheckBoxOutlineBlank />
                  )}
                </div>
                <Avatar
                  src={
                    emp?.userProfileResponse?.profilePicId
                      ? `${mediaURL}${emp?.userProfileResponse?.profilePicId}`
                      : null
                  }
                  sx={{ mr: 2 }}
                />
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'start',
                    flexDirection: 'column',
                  }}
                >
                  <strong>{emp?.businessMember?.name}</strong>
                  <span>{emp?.businessMember?.email}</span>
                </div>
              </AddEmployeesToWebinarListItem>
            ))}
          </div>
        )}
      </AddEmployeesDialogContent>
      <DialogActions>
        <StyledAddStaffButton btnColor="none" onClick={closeDialog}>
          Close
        </StyledAddStaffButton>
        <AddEmployeesButton
          disabled={saving || selectedEmployees?.length <= 0}
          onClick={handleAddEmployeesToWebinar}
        >
          {saving && <CircularProgress size={20} sx={{ position: 'absolute', color: '#6e63c4' }} />}
          <span>Add Employees</span>
        </AddEmployeesButton>
      </DialogActions>
    </>
  )
}
